import axios from "axios"

const API = axios.create({baseURL:"https://slottaby-api.onrender.com"})  //http://localhost:5000 --https://slottaby-api.onrender.com

API.interceptors.request.use((req)=>{
    if(localStorage.getItem("user_info")){
        req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem("user_info")).token}`
    }
    return req;
})

export const Login = (data) => API.post("/users/login", data)
export const Register = (data) => API.post("/users/register", data)

export const SaveEvent = (data) => API.post("/users/saveEvent", data)
export const GetAllEvents = (data) => API.post("/users/getAllEvents", data)

export const PunchInorOutEvent = (data) => API.post("/users/punchInorOutEvent", data)
export const DeleteEvent = (data) => API.post("/users/deleteEvent", data)

export const GetAdminData = (data) => API.post("/users/getAdminData", data)
export const SubmitApproval = (data) => API.post("/users/submitApproval", data)